import { toSignal } from '@angular/core/rxjs-interop';
import { travelRouterTree$ } from '../utils/travel-router-tree.util';
import {startWith, tap} from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

export const $getRouteDataByParam = <TDefault>(param: string, defaultValue: TDefault) =>
  toSignal<TDefault, TDefault>(
    travelRouterTree$((route) => {
      while (route.firstChild && !route.snapshot?.data[param]) {
        route = route.firstChild;
      }

      return route;
    }).pipe(
      mergeMap((route) => route?.data),
      map((data) => data[param]),
      startWith(defaultValue),
    ),
    { initialValue: defaultValue },
  );
